module.exports = __webpack_public_path__ + "static/media/facebook3.587b3a05.png";